import s from "./homeLanding.module.css";

const SIZE_CLASS = {
  lg: s.deviceLg,
  md: s.deviceMd,
  sm: s.deviceSm,
};

/** React 18 expects lowercase `fetchpriority` on DOM nodes. */
function imgLoadProps(priority) {
  if (!priority) {
    return { loading: "lazy", decoding: "async" };
  }
  return { loading: "eager", decoding: "async", fetchpriority: "high" };
}

export default function LandingPhoneFrame({
  src,
  alt = "",
  size = "md",
  className = "",
  priority = false,
  variant = "screenshot",
  children = null,
  screenClassName = "",
}) {
  if (!src && !children) return null;

  const sizeClass = SIZE_CLASS[size] || SIZE_CLASS.md;
  const variantClass = variant === "device" ? "" : s.deviceScreenshot;

  return (
    <div
      className={`${s.device} ${sizeClass} ${variantClass} ${className}`.trim()}
    >
      <div className={s.deviceBezel}>
        <div className={`${s.deviceScreen} ${screenClassName}`.trim()}>
          <div className={s.deviceIsland}>
            <span className={s.deviceIslandCam} />
          </div>
          {children || (
            <img
              src={src}
              alt={alt}
              {...imgLoadProps(priority)}
            />
          )}
          <div className={s.deviceHomeBar} />
        </div>
      </div>
    </div>
  );
}
